{ProductDetails,EventDetails,OrgDetails,NavigationItems,UserDetails,SettingsRouter,SettingsNav,EcommerceNav,EcommerceRouter} = window.DuocmsAdmin.modules # copy original components

window.DuocmsAdmin.modules.UserModal = require("./admin/UserModal") # create override, giving original
window.DuocmsAdmin.modules.ProductDetails = require("./admin/ProductDetails")(ProductDetails) # create override, giving original
window.DuocmsAdmin.modules.EventDetails = require("./admin/EventDetails")(EventDetails) # create override, giving original
window.DuocmsAdmin.modules.OrgDetails = require("./admin/OrgDetails")(OrgDetails) # create override, giving original
window.DuocmsAdmin.modules.UserDetails = require("./admin/UserDetails")(UserDetails) # create override, giving original
window.DuocmsAdmin.modules.EventsList = require("./admin/EventList") # create override, giving original
window.DuocmsAdmin.modules.InvoiceFooter = require("./admin/InvoiceFooter") 
window.DuocmsAdmin.modules.UserDownloadsTab = require("./admin/UserDownloadsTab") 

window.DuocmsAdmin.modules.LuluPanel = require("./admin/LuluPanel") 
window.DuocmsAdmin.modules.LuluList = require("./admin/LuluList") 
window.DuocmsAdmin.modules.LuluModal = require("./admin/LuluModal") 

NewSettingsRouter = ({React,Route,InvoiceFooter})->
  (props)->
    routes = SettingsRouter(props)
    routes.push(<Route key="invoice_footer" path="/settings/ecommerce_nafems" component={InvoiceFooter} />)
    routes
    
NewSettingsNav = ({React,Navli})->
  (props)->
    olditems = SettingsNav(props)
    olditems.concat([<Navli key="ecommerce_nafems" className="btn btn-default btn-block" to="/settings/ecommerce_nafems" location={props.location}>NAFEMS Ecommerce</Navli>])

NewEcommerceRouter = ({React,Route,LuluPanel,ProductModal})->
  (props)->
    routes = EcommerceRouter(props)
    console.log(routes)
    routes.push(<Route key="lulu" path="/ecommerce/lulu" component={LuluPanel} />)
    routes = routes.filter (r)=> r.key !="product"  #remove old product modal
    routes.push(<Route key="product" path="/ecommerce/products/:product_id" component={ProductModal} />)
    routes


NewEcommerceNav = ({React,Navli})->
  (props)->
    olditems = EcommerceNav(props)
    olditems.concat([<Navli key="lulu" className="btn btn-default btn-block" to="/ecommerce/lulu" location={props.location}>Lulu Jobs</Navli>])

window.DuocmsAdmin.modules.SettingsNav = NewSettingsNav
window.DuocmsAdmin.modules.SettingsRouter = NewSettingsRouter
window.DuocmsAdmin.modules.EcommerceNav = NewEcommerceNav
window.DuocmsAdmin.modules.EcommerceRouter = NewEcommerceRouter
window.DuocmsAdmin.modules.LuluActions = require("./admin/LuluActions")

{ collectionReducer, selectionReducer, boolReducer, stringReducer, toggleReducer, arrayReducer, objectReducer, numberReducer } = window.DuocmsAdmin.modules.SharedReducers

reducers = 
  lulus:collectionReducer("LULU"), 
  lulusSearchTerm:stringReducer("LULUS_SEARCH_TERM"),
  lulusAreLoading:boolReducer("LULUS_ARE_LOADING"),
  lulusAreEditing:boolReducer("LULUS_ARE_EDITING"),
  lulusAdding:boolReducer("LULUS_ADDING"),
  lulusSelected:selectionReducer("LULU"),
  lulusSelectedAreLoading:boolReducer("LULUS_SELECTED_ARE_LOADING"),
  lulusAreSaving:boolReducer("LULUS_ARE_SAVING"),
  luluSavedSuccess:arrayReducer("LULU_SAVED_SUCCESS"),

Object.assign(window.DuocmsAdmin.modules.reducers,reducers)

window.DuocmsAdmin.start()